import { combineReducers } from 'redux';
import {userReducer, UserState} from "./user/UserReducer";
import thunk from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import { reducer as formReducer } from 'redux-form';
import {casinoReducer, CasinoState} from "./casino/CasinoReducer";
import {navigationReducer, NavigationState} from "./navigation/NavigationReducer";
import {PaymentsState} from "./payments/PaymentsReducer";
import {paymentsReducer} from "./payments/PaymentsReducer";
import {contentfulReducer, ContentfulState} from "./contenful/ContentfulReducer";
import {settingsReducer, SettingsState} from "./settings/SettingsReducer";
import {storeReducer, StoreState} from "./store/StoreReducer";
import {bonusReducer, BonusStoreState} from "./bonus/BonusReducer";
import {messageReducer, MessageState} from "./messages/MessagesReducer";
import {userRewardReducer, UserRewardState} from "./rewards/UserRewardReducer";
import {userJourneyReducer, UserJourneyState} from "./journey/UserJourneyReducer";
import { composeWithDevTools } from 'redux-devtools-extension'
import {TypedUseSelectorHook, useSelector} from "react-redux";
import { popupReducer, PopupState } from './popup/PopupReducer';
export interface AppState {
    user : UserState;
    casino: CasinoState;
    navigation : NavigationState;
    payments : PaymentsState,
    contentful: ContentfulState,
    settings: SettingsState,
    store: StoreState
    bonus : BonusStoreState;
    message : MessageState;
    rewards : UserRewardState;
    journey: UserJourneyState;
    popup: PopupState;
}

const rootReducer = combineReducers({
    user: userReducer as any,
    casino: casinoReducer as any,
    navigation : navigationReducer as any,
    payments : paymentsReducer as any,
    form: formReducer,
    contentful: contentfulReducer,
    settings: settingsReducer,
    store: storeReducer,
    bonus : bonusReducer,
    rewards : userRewardReducer,
    message : messageReducer as any,
    journey : userJourneyReducer,
    popup: popupReducer
});

export function configureStore() {
    const middlewares = [thunk];
    const composedEnhancers = composeWithDevTools({
        trace: true // Enable tracing of action calls
      })(applyMiddleware(...middlewares));
    const store = createStore(rootReducer, process.env.NODE_ENV === 'development' ? composedEnhancers : applyMiddleware(...middlewares));
    return store 
}

export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;